import type IsoDate from '../../../models/IsoDate';
import { requestAndParse, requestSuccessful } from '../request';

const setNotes = async (
    studentId: number,
    chartDate: IsoDate,
    notes?: string,
    internalNotes?: string,
) => {
    const route = 'charts/set-notes';

    const payload = {
        studentId,
        chartDate,
        notes,
        internalNotes,
    };

    const response = await requestAndParse(route, payload);

    return {
        success: requestSuccessful(response),
        error: response.body?.message as string | undefined,
    };
};

export default setNotes;
